import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'project-directories.versions.release-version-modal.header',
		defaultMessage: 'Release {name}',
		description: '',
	},
	release: {
		id: 'project-directories.versions.release-version-modal.release',
		defaultMessage: 'Release',
		description: '',
	},
	cancel: {
		id: 'project-directories.versions.release-version-modal.cancel',
		defaultMessage: 'Cancel',
		description: '',
	},
});
